import React, { useState, useEffect } from 'react';
import { View, Text, StyleSheet, TextInput, TouchableOpacity, Platform } from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { colores, fuentes } from '../../styles/variablesCss';
import { useUser } from '../../context/UserContext';
import { useCheckoutContext } from '../../context/CheckoutContext';

const DatosFacturacion = () => {
  const { nombreUsuario, mail, cel } = useUser();
  const { deseaFactura, setDeseaFactura, tipoResponsable, setTipoResponsable, razonSocial, setRazonSocial,
    cuit, setCuit, nombreAutorizado, setNombreAutorizado, dniAutorizado, setDniAutorizado, observaciones,
    setObservaciones, aceptaReemplazo, setAceptaReemplazo, telefonoDireccionPrincipal, telefonoFacturacion, setTelefonoFacturacion } = useCheckoutContext();

  // Estado para controlar responsividad
  const [windowWidth, setWindowWidth] = useState(
    Platform.OS === 'web' && typeof window !== 'undefined' ? window.innerWidth : 768
  );
  const isMobile = windowWidth < 768;

  // Listener para cambios de tamaño de ventana
  useEffect(() => {
    if (Platform.OS === 'web' && typeof window !== 'undefined') {
      const handleResize = () => {
        setWindowWidth(window.innerWidth);
      };
      
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }
  }, []);

  useEffect(() => {
    if (!telefonoFacturacion && telefonoDireccionPrincipal) {
      setTelefonoFacturacion(telefonoDireccionPrincipal);
    }
  }, [telefonoDireccionPrincipal]);

  // Estilos dinámicos
  const dynamicStyles = {
    columnasContainer: {
      ...styles.columnasContainer,
      flexDirection: isMobile ? 'column' : 'row',
    },
    columnaIzquierda: {
      ...styles.columnaIzquierda,
      flex: isMobile ? undefined : 1,
      width: isMobile ? '100%' : undefined,
      marginRight: isMobile ? 0 : 16,
      marginBottom: isMobile ? 0 : 0,
    },
    columnaDerecha: {
      ...styles.columnaDerecha,
      flex: isMobile ? undefined : 1,
      width: isMobile ? '100%' : undefined,
    },
    seccionTitulo: {
      ...styles.seccionTitulo,
      fontSize: isMobile ? 14 : 16,
    },
    autorizadoContainer: {
      ...styles.autorizadoContainer,
      flexDirection: isMobile ? 'row' : 'column',
      justifyContent: isMobile ? 'space-between' : 'flex-start',
    },
    inputWrapper: {
      width: isMobile ? '48%' : '100%',
      marginBottom: isMobile ? 0 : 15,
    },
    checkboxesContainer: {
      flexDirection: isMobile ? 'column' : 'row',
      justifyContent: isMobile ? 'flex-start' : 'space-between',
      alignItems: isMobile ? 'flex-start' : 'center',
      width: '100%',
      gap: isMobile ? 5 : 20,
      marginVertical: 5,
    },
    checkboxWrapper: {
      flex: isMobile ? undefined : 1,
      width: isMobile ? '100%' : undefined,
    },
  };

  return (
    <View style={styles.container}>
      <View style={styles.formContainer}>
        <View style={dynamicStyles.columnasContainer}>
          {/* Columna izquierda: Datos personales (no editables) */}
          <View style={dynamicStyles.columnaIzquierda}>
            <Text style={[dynamicStyles.seccionTitulo, styles.seccionTituloBadge]}>Datos del comprador</Text>
            <View style={styles.datosPersonalesContainer}>
              <View style={styles.datoItem}>
                <Text style={styles.datoLabel}>Nombre y Apellido</Text>
                <Text style={styles.datoValor}>{nombreUsuario}</Text>
              </View>

              <View style={styles.datoItem}>
                <Text style={styles.datoLabel}>Email</Text>
                <Text style={styles.datoValor}>{mail}</Text>
              </View>

              <View style={styles.datoItem}>
                <Text style={styles.datoLabel}>Teléfono</Text>
                <TextInput
                  style={[styles.facturaInput, { width: 'auto', flex: 1, marginBottom: 0 }]}
                  placeholder="Teléfono"
                  placeholderTextColor="#666"
                  keyboardType="phone-pad"
                  value={telefonoFacturacion || telefonoDireccionPrincipal || ''}
                  onChangeText={(t) => setTelefonoFacturacion(t)}
                />
              </View>
            </View>
          </View>

          {/* Columna derecha: Persona autorizada (campos editables) */}
          <View style={dynamicStyles.columnaDerecha}>
            <Text style={[dynamicStyles.seccionTitulo, styles.seccionTituloBadge]}>Autorizo a retirar a:</Text>
            <View style={dynamicStyles.autorizadoContainer}>
              {/* Input de Nombre y Apellido */}
              <View style={dynamicStyles.inputWrapper}>
                {!isMobile && <Text style={styles.autorizadoLabel}>Nombre y Apellido:</Text>}
                <TextInput
                  style={styles.inputAutorizado}
                  placeholder="Nombre y Apellido"
                  placeholderTextColor="#999"
                  value={nombreAutorizado}
                  onChangeText={(text) => {
                    setNombreAutorizado(text);
                    
                  }}
                />
              </View>

              {/* Input de DNI */}
              <View style={dynamicStyles.inputWrapper}>
                {!isMobile && <Text style={styles.autorizadoLabel}>DNI de la persona autorizada (Será solicitado):</Text>}
                <TextInput
                  style={styles.inputAutorizado}
                  placeholder={isMobile ? "DNI" : "Número de documento"}
                  placeholderTextColor="#999"
                  value={dniAutorizado}
                  keyboardType="numeric"
                  onChangeText={(text) => {
                    setDniAutorizado(text);
                  }}
                />
              </View>
            </View>
          </View>
        </View>

        {/* Campo para observaciones */}
        <View style={styles.observacionesContainer}>
          <Text style={dynamicStyles.seccionTitulo}>Observaciones</Text>
          <TextInput
            style={styles.observacionesInput}
            placeholder="Ingrese sus observaciones aquí"
            placeholderTextColor="#999"
            multiline={true}
            numberOfLines={3}
            value={observaciones}
            onChangeText={(text) => {
              setObservaciones(text);
             
            }}
          />
        </View>

        {/* Contenedor para checkboxes en fila o columna según el tamaño */}
        <View style={dynamicStyles.checkboxesContainer}>
          {/* Checkbox para Aceptar reemplazo */}
          <View style={dynamicStyles.checkboxWrapper}>
            <TouchableOpacity
              style={styles.checkboxRow}
              onPress={() => {
                const nuevoValor = !aceptaReemplazo;
                setAceptaReemplazo(nuevoValor);
              }}
            >
              <MaterialCommunityIcons
                name={aceptaReemplazo ? "checkbox-marked" : "checkbox-blank-outline"}
                size={28}
                color={colores.rojo}
              />
              <Text style={styles.reemplazoLabel}>¿Reemplazar mercadería por faltantes?</Text>
            </TouchableOpacity>
          </View>

          {/* Checkbox para Factura A o B */}
          <View style={dynamicStyles.checkboxWrapper}>
            <TouchableOpacity
              style={styles.checkboxRow}
              onPress={() => {
                const nuevoValor = !deseaFactura;
                setDeseaFactura(nuevoValor);
              }}
            >
              <MaterialCommunityIcons
                name={deseaFactura ? "checkbox-marked" : "checkbox-blank-outline"}
                size={28}
                color={colores.rojo}
              />
              <Text style={styles.facturaLabel}>¿Desea Factura A o B?</Text>
            </TouchableOpacity>
          </View>
        </View>

        {/* Campos adicionales para facturación */}
        {deseaFactura && (
          <View style={styles.facturaFormContainer}>
            {Platform.OS === 'web' ? (
              <View style={styles.selectContainer}>
                <select
                  style={styles.selectWeb}
                  value={tipoResponsable}
                  onChange={(e) => {
                    const nuevoValor = e.target.value;
                    setTipoResponsable(nuevoValor);
                                      }}
                >
                  <option value="1">Responsable Inscripto</option>
                  <option value="2">IVA Exento</option>
                  <option value="3">Monotributista</option>
                </select>
                <MaterialCommunityIcons
                  name="chevron-down"
                  size={20}
                  color={colores.textoPrincipal}
                  style={styles.selectIcon}
                />
              </View>
            ) : (
              <TouchableOpacity style={styles.selectInput}>
                <Text>{tipoResponsable}</Text>
              </TouchableOpacity>
            )}

            <TextInput
              style={styles.facturaInput}
              value={razonSocial}
              onChangeText={(text) => {
                setRazonSocial(text);
                              }}
              placeholder="Nombre / Razón social:"
              placeholderTextColor="#666"
            />

            <TextInput
              style={styles.facturaInput}
              value={cuit}
              onChangeText={(text) => {
                setCuit(text);
              }}
              placeholder="CUIT:"
              placeholderTextColor="#666"
              keyboardType="numeric"
            />
          </View>
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
  },
  columnasContainer: {
    flexDirection: Platform.OS === 'web' ? 'row' : 'column',
    justifyContent: 'space-between',
    width: '100%',
  },
  columnaIzquierda: {
    width: Platform.OS === 'web' ? '48%' : '100%',
  },
  columnaDerecha: {
    width: Platform.OS === 'web' ? '48%' : '100%',
  },
  formContainer: {
    width: '100%',
  },
  datosPersonalesContainer: {
    width: '100%',
    paddingBottom: 10,
  },
  seccionTitulo: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 10,
    color: colores.textoPrincipal,
  },
  seccionTituloBadge: {
    backgroundColor: colores.rojo,
    color: colores.blanco,
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 4,
    alignSelf: 'flex-start',
  },
  autorizadoContainer: {
    width: '100%',
    flexDirection: 'column',
  },
  inputAutorizado: {
    width: '100%',
    height: 40,
    borderWidth: 1,
    borderColor: '#E0E0E0',
    borderRadius: 5,
    paddingHorizontal: 15,
    fontSize: 16,
    backgroundColor: colores.blanco,
    marginBottom: 15,
  },
  autorizadoLabel: {
    fontSize: 14,
    fontWeight: 'normal',
    marginBottom: 5,
    color: colores.textoPrincipal,
  },
  datoItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10,
    width: '100%',
  },
  datoLabel: {
    width: 120,
    fontSize: 14,
    color: '#666',
    marginBottom: 2,
  },
  datoValor: {
    fontSize: 16,
    fontWeight: 'bold',
    color: colores.textoPrincipal,
    flex: 1,
  },
  checkboxRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  facturaLabel: {
    fontSize: 16,
    fontWeight: 'bold',
    color: colores.textoPrincipal,
    marginLeft: 10,
  },
  reemplazoLabel: {
    fontSize: 16,
    fontWeight: 'bold',
    color: colores.textoPrincipal,
    marginLeft: 10,
  },
  facturaFormContainer: {
    backgroundColor: '#f9f9f9',
    padding: 15,
    borderRadius: 5,
    marginTop: 10,
    marginBottom: 15,
  },
  selectContainer: {
    position: 'relative',
    width: '100%',
    marginBottom: 10,
  },
  selectWeb: {
    width: '100%',
    height: 40,
    borderWidth: 1,
    borderColor: '#E0E0E0',
    borderRadius: 5,
    paddingHorizontal: 15,
    paddingRight: 40,
    fontSize: 16,
    backgroundColor: colores.blanco,
    appearance: 'none',
    marginBottom: 15,
  },
  selectIcon: {
    position: 'absolute',
    right: 15,
    top: 12,
    pointerEvents: 'none',
  },
  facturaInput: {
    width: '100%',
    height: 40,
    borderWidth: 1,
    borderColor: '#E0E0E0',
    borderRadius: 5,
    paddingHorizontal: 15,
    fontSize: 16,
    backgroundColor: colores.blanco,
    marginBottom: 15,
  },
  selectInput: {
    width: '100%',
    height: 40,
    borderWidth: 1,
    borderColor: '#E0E0E0',
    borderRadius: 5,
    paddingHorizontal: 15,
    justifyContent: 'center',
    backgroundColor: colores.blanco,
    marginBottom: 15,
  },
  observacionesContainer: {
    width: '100%',
  },
  observacionesInput: {
    width: '100%',
    minHeight: 80,
    borderWidth: 1,
    borderColor: '#E0E0E0',
    borderRadius: 5,
    paddingHorizontal: 15,
    paddingVertical: 10,
    fontSize: 16,
    backgroundColor: colores.blanco,
    textAlignVertical: 'top',
  },
});

export default DatosFacturacion;
